var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full bg-white rounded-md mt-12 big-shadow p-5"},[_c('ModifierSets',{attrs:{"in-view-mode":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }